<div class="container">
<nav
      class="navbar navbar-expand-lg navbar-light fixed-top shadow-sm"
      id="mainNav"
    >
      <div class="container px-5">
        <a class="navbar-brand fw-bold" href="#page-top">
          <img src="./assets/img/doktorslogo.png" style="width:150px"
        /></a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
          >
          Menu
          <i class="bi-list"></i>
        </button>
    </div>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <a class="btn btn-primary" href="patlog"> BOOK APPOINTMENT</a>
        </div>
    </nav>
    <img src="./assets/img/symptoms.png" style="z-index:-1;position: absolute; opacity: .2; height: 100%;">
    <section>
      <section style="padding-bottom: 0px;">
        
      <div class="container">
        <div class="row text-center" >
        <div class="col-md-3">
          <img class="img-fluid" id="doctorprofile" [src]="path + CityDoctor?.data?.profileImage" *ngIf="CityDoctor?.data?.profileImage">
          <img id="doctorprofile" src="assets/img/doctor.png" class="img-fluid" alt="" *ngIf="!CityDoctor?.data?.profileImage" >
          <p id="activedoctor" *ngIf="isactive"><i>Active</i></p>
        </div>
        <div class="col-md-3" style="    text-align: initial;">
          <div class="column">
            <h1>Dr. {{CityDoctor?.data?.name}}</h1>
            <h4>{{CityDoctor?.data?.degree}}</h4>
            <h6>{{CityDoctor?.data?.experience}} years experience</h6>
            
              
            <img class="img-fluid" style="height: 30px;" src="./assets/img/symbol.png">
          
            <p style="display: inline;
            color: #009245;">Verified</p>
          
          
        </div>
        </div>
        <div class="col-md-5" style="    text-align: initial;">

          <div class="row" style="    padding-top: 10px;">
            <div class="col-md-12">
              <div class="column">
                <p>Verified Medical Council Id :<b>{{" "+CityDoctor?.data?.mcId}}</b></p>
                <p>Membership :<b>{{" "+CityDoctor?.data?.membership}}</b></p>
                <h1>Attending TOKEN NO : {{clinicArray?.appointmentNumber}}</h1>
              </div>
            </div>
            <!-- <div class="col-md-6">
              <div class="column">
                <h4>{{CityDoctor?.data?.mcId}}</h4>
                <h4>{{CityDoctor?.data?.membership}}</h4>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <ul class="nav nav-tabs">
        <li
          class="nav-item"
          *ngFor="let item of CityDoctor?.data?.clinicId; let index = index"
        >
          <a
            [href]="'#' + index"
            (click)="changeclinic(index)"
            class="nav-link"
            [ngClass]="{'active':curindex == index }"
            data-toggle="tab"
          >
            {{item?.clinicName}}
            <h6 style="color: rgb(21, 192, 135);">
              {{item?.clinicStatus}}
            </h6>
          </a>
        </li>
        <!-- <li class="nav-item">
            <a href="#profile" class="nav-link" data-toggle="tab">Profile</a>
                    </li>
                    <li class="nav-item">
                        <a href="#messages" class="nav-link" data-toggle="tab">Messages</a>
                    </li> -->
      </ul>
      </div>
    </section>
      <!-- clinic section -->
      <section *ngIf="istrue">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="margin-bottom: 10px;">
             
              
              <h3>Availability (WEEK)</h3>
              <div class="row" style="margin-left: 0;">
                <p *ngFor="let day of clinicArray?.weekDays" id="weekicon"> {{" "+" "+day.substr(0,3)+" "+" "}} </p>
              </div>
              
              
                <h6>Paitient Limit : <b style="color: #009245;">{{" "+clinicArray?.patientLimit}}</b></h6>
                <h6>Opening Time : <b style="color: #009245;">{{" "+moment(clinicArray?.timming.startTime,['h:mm']).format('hh:mm A')}}</b></h6>
                <h6>Closing Time : <b style="color: #009245;">{{" "+ moment(clinicArray?.timming.endTime,['h:mm']).format('hh:mm A')}}</b></h6>
             
            
            
              </div>
              <div class="col-md-6">
                <div class="column">
                  
                  <h1>Address</h1>
                  <p class="text-capitalize">{{clinicArray?.address?.line1 +","+clinicArray?.address?.city +" "+ clinicArray?.address?.district +" "+ clinicArray?.address?.state +" "+ clinicArray?.address?.pincode}}</p>
                <h6>Services</h6>
                <ul>
                  <li *ngFor="let service of CityDoctor?.data?.services">{{service}}</li>
                </ul>
              </div>
            </div>
      </div>
      <h1>Cllinic Image</h1>
      <img  data-toggle="modal" data-target="#exampleModal" *ngFor="let image of clinicArray?.clinicImages; let i = index" (click)="veiwimg(i)" class="img-thumbnail" [src]="this.path + image">
    </div>
    </section>
    </section>
  </div>
    <footer id="footer">
      <div class="footer-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-6 footer-contact">
              <!-- <h3>Resi.</h3> -->
              <img
                src="./assets/img/doktorslogo.png"
                style="width:150px;z-index:999;"
              />
              <p>
                A108 Adam Street <br />
                New York, NY 535022<br />
                United States <br /><br />
                <strong>Phone:</strong> +1 5589 55488 55<br />
                <strong>Email:</strong> help@doqmatokens.com<br />
              </p>
            </div>

            <div class="col-lg-2 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <!-- <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">Home</a>
                </li> -->
                <!-- <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">About us</a>
                </li> -->
                <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">Services</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="termsconditoin">Terms of service</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="privacypolicy">Privacy policy</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="refundpolicy">Refund policy</a>
                </li>
              </ul>
            </div>

            <div class="col-lg-3 col-md-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">Doctor</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="#">Patient</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="#">Member</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">Marketing</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="#">Graphic Design</a>
                </li>
              </ul>
            </div>

            <div
              class="col-lg-4 col-md-6 footer-newsletter"
              style="text-align:center"
            >
              <h4>Download the app now</h4>
              <p>
                Get latest news on DOQMA on your mail and stay connected.
              </p>
              <!-- <form action="" method="post">
                <input type="email" name="email" /><input
                  type="submit"
                  value="Subscribe"
                />
              </form> -->
              <a class="me-lg-3 mb-4 mb-lg-0" href="https://play.google.com/store/apps/details?id=com.paspatient"
                ><img
                  class="app-badge"
                  src="assets/img/google-play-badge.svg"
                  alt="..."
              /></a>
            </div>
          </div>
        </div>
      </div>

      <div class="container d-md-flex py-4">
        <div class="mr-md-auto text-center text-md-left">
          <div class="copyright">
            &copy; Copyright <strong><span>Mavin Globus</span></strong
            >. All Rights Reserved
          </div>
        </div>
        <div class="social-links text-center text-md-right pt-3 pt-md-0">
          <!-- <a href="#" class="twitter"><i class="bi bi-twitter"></i></a> -->
          <!-- <a href="#" class="facebook"><i class="bi bi-facebook"></i></a> -->
          <!-- <a href="#" class="instagram"><i class="bi bi-instagram"></i></a> -->
          <!-- <a href="#" class="google-plus"><i class="bi bi-skype"></i></a> -->
          <!-- <a href="#" class="linkedin"><i class="bi bi-linkedin"></i></a> -->
        </div>
      </div>
    </footer>



          <!-- modal for view clinic-image -->
          <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <!-- <form [formGroup]="viewclinicForm">
                    <img formControlName="imgForm">
                  </form> -->
                  <img style="height: 400px;" [src]="this.path + clinicArray?.clinicImages[imgindex]" class="img-fluid">
                  <!-- <a class="carousel-control-prev" (click)="dcCounter()" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a class="carousel-control-next" (click)="incCounter()" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                  </a> -->
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-success" (click)="dcCounter()">Prev</button>
                  <button type="button" class="btn btn-primary" (click)="incCounter()">Next</button>
                </div>
              </div>
            </div>
          </div>


          <div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Select Clinic</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row" style="padding-bottom: 20px;" *ngFor="let item of CityDoctor?.data?.clinicId; let index = index">
                    <div class="col-md-4">
                      <img style="height: 80px;" [src]="this.path + item?.clinicImages[0] ">
                    </div>
                    <div class="col-md-4">
                      {{item?.clinicName}}
                    </div>
                    <div class="col-md-4">
                      <button class="btn btn-primary"  >{{item?.clinicName}}</button>
                    </div>
                  </div>
                  <button class="btn btn-primary" *ngFor="let item of CityDoctor?.data?.clinicId; let index = index" style="display: block; margin-bottom: 10px;">{{item?.clinicName}}</button>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                </div>
              </div>
            </div>
          </div>